export default __webpack_public_path__ + "static/media/buy-icon-light.16a76836.svg";